import { useContext } from "react";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setUbicacion } from "_+_Portal/_-_Autocheckin/context/action/ubicacion";
import { Geolocation } from "@capacitor/geolocation";
import { EstaEnDim, listarCentros } from "../PagesFun";
import {
  setIdTipoPuntoControl,
  wsGetPuntoControlTexto,
} from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { getLocalStorage } from "global/utils/safeJsonParse";

const UbicacionActual = ({ setLoading, setError, turnoActual }) => {
  // -------------------------  context ----------------------------
  const {
    pasoDispatch,
    ubicacionDispatch,
    turnosAutoCheckInState,
    turnosSeleccionadosState,
    puntoControlDispatch,
  } = useContext(AutocheckContext);
  const { modalDispatch } = useContext(GlobalContext);
  // -------------------------  context ----------------------------

  // -------------------------  constants ----------------------------
  const turnos = turnosAutoCheckInState.turnosAutoCheckIn?.data;
  const result = turnosSeleccionadosState.turnosSeleccionados?.data?.[turnoActual];
  const centros = listarCentros([result]);
  const config = getLocalStorage("config", {});
  let opcFilaVirtual = config?.opcFilaVirtual;
  // -------------------------  constants ----------------------------

  // -------------------------  funciones ----------------------------
  const handleClickOne = () => {
    setUbicacion(true)(ubicacionDispatch);
    setPaso("NumeroAfiliado")(pasoDispatch);
    // setLoading("Cargando ...");
    // setPaso("Loading")(pasoDispatch);
    // Geolocation.getCurrentPosition()
    //   .then((resp) => {
    //     const latitud = resp.coords.latitude;
    //     const longitud = resp.coords.longitude;
    //     let location = EstaEnDim(latitud, longitud, centros);
    //     if (location) {
    //       if (location && location.length > 0) {
    //         setUbicacion(true)(ubicacionDispatch);
    //         setPaso("NumeroAfiliado")(pasoDispatch);
    //       } else {
    //         showModalInformacion(location);
    //       }
    //     } else {
    //       wsGetPuntoControlTexto(
    //         20,
    //         -1,
    //         -1
    //       )((isCorrect, data) => errorsHandle(isCorrect, data, 20));
    //     }
    //   })
    //   .catch((error) => {
    //     setUbicacion(false)(ubicacionDispatch);
    //     wsGetPuntoControlTexto(
    //       19,
    //       -1,
    //       -1
    //     )((isCorrect, data) => errorsHandle(isCorrect, data, 19));
    //   });
  };

  const showModalInformacion = (dataTurnos) => {
    // Obtener los IDs presentes en turnos
    const turnosIds = dataTurnos.map((turno) => turno.idturno);
    // Filtrar los IDs que no están en turnosIds
    const MatchingIds =
      (turnosSeleccionadosState.turnosSeleccionados?.data ?? []).filter((id) =>
        turnosIds.includes(id)
      );
    const nonMatchingIds =
      (turnosSeleccionadosState.turnosSeleccionados?.data ?? []).filter(
        (id) => !turnosIds.includes(id)
      );
    const turnosSinRecepcionar = (turnos ?? []).filter((turno) =>
      nonMatchingIds.includes(turno.idturno)
    );
    setUbicacion(false)(ubicacionDispatch);
    setPaso("NumeroAfiliado")(pasoDispatch);
    showModal(
      <ModalAutoT
        dissmiss={dissmiss}
        desc={
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <p>
              Los siguientes turnos no se pueden recepcionar debido a la
              distancia con el centro:
            </p>
            {turnosSinRecepcionar.map((item, key) => {
              return (
                <li key={key}>
                  {item.especialidad} - {item.centro}
                </li>
              );
            })}
          </div>
        }
        title={"Información"}
        textBtnOne={"Continuar"}
        handleChange={{
          btnOne: () => {
            dissmiss();
            setPaso("NumeroAfiliado")(pasoDispatch);
          },
        }}
      />,
      "Información",
      dissmiss,
      false,
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const errorsHandle = (isCorrect, data, id) => {
    setUbicacion(false)(ubicacionDispatch);
    let mensaje = "Error al recepcionar";
    if (id === 18) {
      mensaje = data.porDefecto
        ? "No es posible recepcionar turnos desde esta plataforma si no se encuentra en uno de nuestros centros de DIM"
        : data.descripcion;
    } else if (id === 19) {
      mensaje = data.porDefecto
        ? "Para poder detectar su ubicación debe activarla desde la configuracion de su dispositivo"
        : data.descripcion;
    } else if (id === 20) {
      mensaje = data.porDefecto
        ? "Usted se encuentra lejos del centro"
        : data.descripcion;
    }
    if (!isCorrect) {
      setError({
        message: "Error al recepcionar turno",
        errorBack: id === 20 ? "Home" : "UbicacionActual",
      });
    } else {
      setError({
        message: mensaje,
        errorBack: "Home",
      });
    }
    setIdTipoPuntoControl(id)(puntoControlDispatch);
    setPaso("ModalErrorAutoT")(pasoDispatch);
  };

  const handleClickTwo = () => {
    if (opcFilaVirtual) {
      setPaso("NumeroAfiliado")(pasoDispatch);
    } else {
      wsGetPuntoControlTexto(
        18,
        -1,
        -1
      )((isCorrect, data) => errorsHandle(isCorrect, data, 18));
    }
    setUbicacion(false)(ubicacionDispatch);
  };
  // -------------------------  funciones ----------------------------

  return (
    <ModalAutoT
      title={`¿Usted se encuentra en DIM? `}
      desc={`Le solicitamos está información para que usted pueda realizar los siguientes tramites`}
      textBtnOne={"SI"}
      textBtnTwo={"NO"}
      handleChange={{ btnOne: handleClickOne, btnTwo: handleClickTwo }}
    />
  );
};

export default UbicacionActual;
